import { NgModule, LOCALE_ID, CUSTOM_ELEMENTS_SCHEMA} from '@angular/core';
import { DatePipe, IMAGE_CONFIG } from "@angular/common";
import { BrowserModule } from '@angular/platform-browser';
import { AppRoutingModule } from './app-routing.module';
import { NgxMarqueeComponent } from '@omnedia/ngx-marquee';
import { NgbModule } from '@ng-bootstrap/ng-bootstrap';
import { environment } from '../environments/environment';
import { RECAPTCHA_V3_SITE_KEY, RecaptchaV3Module } from "ng-recaptcha";
import { NgxIntlTelInputModule } from 'ngx-intl-tel-input';
import { ReactiveFormsModule, FormsModule } from "@angular/forms";
import { BsDatepickerModule } from 'ngx-bootstrap/datepicker';
import { TimepickerModule } from 'ngx-bootstrap/timepicker';
import { PaginationModule } from 'ngx-bootstrap/pagination';
import { NgxMasonryModule } from 'ngx-masonry';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { GoogleMapsModule } from "@angular/google-maps";
import { TranslateLoader, TranslateModule } from '@ngx-translate/core';
import { TranslateHttpLoader } from '@ngx-translate/http-loader';
import { HttpClient, provideHttpClient } from "@angular/common/http";
import { NgcCookieConsentModule, NgcCookieConsentConfig } from 'ngx-cookieconsent';
import { ScrollerModule } from 'primeng/scroller';
import { NgxMaskConfig, NgxMaskDirective, provideEnvironmentNgxMask } from 'ngx-mask';

import { registerLocaleData } from '@angular/common';
import pt from '@angular/common/locales/pt';
import en from '@angular/common/locales/en';
registerLocaleData(pt);
registerLocaleData(en);

import { SlugifyPipe } from './Pipes/slugify.pipe';

import { provideMapboxGL, MapComponent, MarkerComponent, PopupComponent, GeoJSONSourceComponent, LayerComponent } from 'ngx-mapbox-gl';

// -----Pages-----
import { AppComponent } from './app.component';
import { FooterComponent } from './Layout/footer/footer.component';
import { HeaderComponent } from './Layout/header/header.component';
import { PageNotFoundComponent } from "./Layout/page-not-found/page-not-found.component";
import { HomepageComponent } from './Layout/homepage/homepage.component';
import { SearchPageComponent } from "./Layout/search-page/search-page.component";
import { SobreNosComponent } from './Pages/Linhas/sobre-nos/sobre-nos.component';
import { LinhasComponent } from './Pages/Viajar/linhas/linhas.component';
import { HorariosComponent } from './Pages/Viajar/horarios/horarios.component';
import { PlaneadorViagensComponent } from './Pages/Viajar/planeador-viagens/planeador-viagens.component';
import { NoticiasComponent } from './Pages/Linhas/noticias/noticias.component';
import { ContactosComponent } from './Pages/Informar/contactos/contactos.component';
import { ApoioPassageiroComponent } from "./Pages/Informar/apoio-passageiro/apoio-passageiro.component";
import { FaqComponent } from "./Pages/Informar/faq/faq.component";
import { ParagensComponent } from "./Pages/Viajar/paragens/paragens.component";
import { DescontosComponent } from "./Pages/Comprar/descontos/descontos.component";
import { TarifariosComponent } from "./Pages/Comprar/tarifarios/tarifarios.component";
import { ViagensOcasionaisComponent } from "./Pages/Comprar/viagens-ocasionais/viagens-ocasionais.component";
import { PontosVendaComponent } from "./Pages/Comprar/pontos-venda/pontos-venda.component";
import { DireitosPassageirosComponent } from "./Pages/Informar/direitos-passageiros/direitos-passageiros.component";
import { PoliticaCookiesComponent } from "./Pages/Informar/politica-cookies/politica-cookies.component";
import { AvisoLegalComponent } from "./Pages/Informar/aviso-legal/aviso-legal.component";
import { PoliticaPrivacidadeComponent } from "./Pages/Informar/politica-privacidade/politica-privacidade.component";
import { TresRiosComponent } from "./Pages/Linhas/tres-rios/tres-rios.component";
import { NoticiasDetalheComponent } from "./Pages/Linhas/noticias/noticias-detalhe/noticias-detalhe.component";
import { ReclamacaoDetalheComponent } from "./Pages/Informar/apoio-passageiro/reclamacao-detalhe/reclamacao-detalhe.component";
import { Error500Component } from "./Layout/error-500/error-500.component";
import { AlertsComponent} from "./Layout/alerts/alerts.component";
import { AcessibilidadeComponent } from "./Pages/Viajar/acessibilidade/acessibilidade.component";
import { ReservarDetalheComponent } from "./Pages/Viajar/acessibilidade/reservar-detalhe/reservar-detalhe.component";

export function HttpLoaderFactory(http: HttpClient) {
  return new TranslateHttpLoader(http, './assets/i18n/', '.json');
}

const maskConfig: Partial<NgxMaskConfig> = { validation: false };

const cookieConfig:NgcCookieConsentConfig = {
  cookie: {
    domain: window.location.hostname
  },
  palette: {
    popup: {
      background: '#003F19',
      text: '#fff',
      link: '#fff'
    },
    button: {
      background: '#00A609',
      text: '#fff'
    }
  },
  position: 'bottom-left',
  theme: 'edgeless',
  type: 'opt-in',
  content: {
    href: "/politica-cookies",
  }
};

@NgModule({
  declarations: [
    AppComponent,
    FooterComponent,
    HeaderComponent,
    HomepageComponent,
    PageNotFoundComponent,
    SobreNosComponent,
    LinhasComponent,
    HorariosComponent,
    PlaneadorViagensComponent,
    NoticiasComponent,
    ContactosComponent,
    ApoioPassageiroComponent,
    FaqComponent,
    ParagensComponent,
    DescontosComponent,
    TarifariosComponent,
    ViagensOcasionaisComponent,
    PontosVendaComponent,
    DireitosPassageirosComponent,
    PoliticaCookiesComponent,
    AvisoLegalComponent,
    PoliticaPrivacidadeComponent,
    TresRiosComponent,
    NoticiasDetalheComponent,
    SearchPageComponent,
    ReclamacaoDetalheComponent,
    Error500Component,
    AlertsComponent,
    AcessibilidadeComponent,
    ReservarDetalheComponent
  ],
  imports: [
    BrowserModule,
    AppRoutingModule,
    NgxMarqueeComponent,
    NgbModule,
    RecaptchaV3Module,
    NgxIntlTelInputModule,
    BrowserAnimationsModule,
    ReactiveFormsModule,
    FormsModule,
    ScrollerModule,
    BsDatepickerModule,
    TimepickerModule,
    GoogleMapsModule,
    PaginationModule,
    NgxMasonryModule,
    TranslateModule.forRoot({
      loader: {
        provide: TranslateLoader,
        useFactory: HttpLoaderFactory,
        deps: [HttpClient]
      }
    }),
    SlugifyPipe,
    NgcCookieConsentModule.forRoot(cookieConfig),
    MapComponent,
    MarkerComponent,
    PopupComponent,
    GeoJSONSourceComponent,
    LayerComponent,
    NgxMaskDirective,
  ],
  exports: [SlugifyPipe],
  providers: [
    provideEnvironmentNgxMask(maskConfig),
    provideHttpClient(),
    { provide: IMAGE_CONFIG, useValue: { disableImageSizeWarning: true, disableImageLazyLoadWarning: true },},
    { provide: RECAPTCHA_V3_SITE_KEY, useValue: environment.recaptcha.siteKey },
    DatePipe,
    { provide: LOCALE_ID, useValue: 'pt' },
    { provide: LOCALE_ID, useValue: 'en' },
    provideMapboxGL({
      accessToken: environment.mapboxToken
    }),
  ],
  schemas: [CUSTOM_ELEMENTS_SCHEMA],
  bootstrap: [AppComponent]
})
export class AppModule {}
